import * as Yup from 'yup'

export const confirmProfileDetailsSchema = Yup.object().shape({
  name: Yup.string()
    .required('Insira o nome!')
    .min(3, 'Mínimo 3 caracteres')
    .max(30, 'Máximo 30 caracteres'),
  cpf: Yup.string()
    .required('Insira o CPF!')
    .test('cpf-valid', 'CPF inválido', (value) => {
      const numbers = value?.replace(/\D/g, '') || ''
      return numbers.length === 11
    }),
  phone: Yup.string()
    .required('Insira um número de telefone.')
    .test('phone-valid', 'Telefone inválido', (value) => {
      const numbers = value?.replace(/\D/g, '') || ''
      const normalized = numbers.startsWith('55') ? numbers.slice(2) : numbers
      return normalized.length === 11 && normalized[2] === '9'
    }),
})

export const profilePhotoValidationSchema = Yup.object().shape({
  profilePhoto: Yup.mixed()
    .nullable()
    .test('fileSize', 'Tamanho máximo 2MB', (file: any) => {
      if (!file) return true

      if (!(file instanceof File)) return true

      return file.size <= 2048 * 1024
    })
    .test('fileType', 'Formato inválido', (file: any) => {
      if (!file) return true

      if (!(file instanceof File)) return true

      return ['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)
    }),
})

export const emailFormValidationSchema = Yup.object().shape({
  newEmail: Yup.string()
    .email('Formato de e-mail incorreto')
    .min(3, 'Mínimo 3 caracteres')
    .max(50, 'Máximo 50 caracteres')
    .required('O e-mail é obrigatório'),

  confirmPassword: Yup.string()
    .min(3, 'Mínimo 3 caracteres')
    .max(50, 'Máximo 50 caracteres')
    .required('A confirmação da senha é obrigatória'),
})

export const passwordFormValidationSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .min(6, 'A senha deve ter pelo menos 6 caracteres.')
    .matches(/[A-Z]/, 'A senha deve conter pelo menos uma letra maiúscula.')
    .matches(/[a-z]/, 'A senha deve conter pelo menos uma letra minúscula.')
    .matches(/\d/, 'A senha deve conter pelo menos um dígito.')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'A senha deve conter pelo menos um caractere especial.')
    .required('Insira uma senha'),
  newPassword: Yup.string()
    .min(6, 'A senha deve ter pelo menos 6 caracteres.')
    .matches(/[A-Z]/, 'A senha deve conter pelo menos uma letra maiúscula.')
    .matches(/[a-z]/, 'A senha deve conter pelo menos uma letra minúscula.')
    .matches(/\d/, 'A senha deve conter pelo menos um dígito.')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'A senha deve conter pelo menos um caractere especial.')
    .required('Insira uma senha')
    .oneOf(
      [Yup.ref('passwordConfirmation')],
      'A senha deve coincidir com o campo (confirme a nova senha)'
    ),
  passwordConfirmation: Yup.string()
    .min(6, 'A senha deve ter pelo menos 6 caracteres.')
    .matches(/[A-Z]/, 'A senha deve conter pelo menos uma letra maiúscula.')
    .matches(/[a-z]/, 'A senha deve conter pelo menos uma letra minúscula.')
    .matches(/\d/, 'A senha deve conter pelo menos um dígito.')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'A senha deve conter pelo menos um caractere especial.')
    .required('Insira uma senha')
    .oneOf([Yup.ref('newPassword')], 'A senha deve coincidir com campo (nova senha)'),
})
